import React, { useState, useEffect } from 'react';
import NavBar from '../../components/NavBar';
import Footer from '../../components/Footer';
import Cookies from 'js-cookie';
import { requestDashboard } from '../../services/requests';

const PaineisMonitoramento = () => {
	const [windowAlert, setWindowAlert] = useState(false);
	const [listUnits, setListUnits] = useState([]);
	const [unitSelector, setUnitSelector] = useState(false);
	const [isOnlyUsuario, setIsOnlyUsuario] = useState(false);
	const [dashboards, setDashboards] = useState([]);
	const [selectedUnit, setSelectedUnit] = useState('');
	const [selectedCategoria, setSelectedCategoria] = useState('');
	const [selectedDashboard, setSelectedDashboard] = useState(null);
	const [selectedDashboardName, setSelectedDashboardName] = useState('');
	const user = Cookies.get('user') ? JSON.parse(Cookies.get('user')) : null;
	const nomeUnidade = user?.unidade_nome?.[0]?.nome;
	const token = user?.token;

	// Buscar dashboards da API local
	// Buscar dashboards da API protegida
	const fetchDashboards = React.useCallback(async () => {
		if (!token) return;
		try {
			const data = await requestDashboard({ token });
			if (Array.isArray(data)) {
				setDashboards(data);
			} else if (Array.isArray(data?.data)) {
				setDashboards(data.data);
			} else {
				setDashboards([]);
			}
		} catch (error) {
			setDashboards([]);
			// Mostra alerta se não autenticado
			if (error?.response?.status === 401) {
				alert(
					'Sua sessão expirou ou você não está autenticado. Faça login novamente para acessar os dashboards.'
				);
			}
		}
	}, [token]);

	// Função para extrair unidades únicas dos dashboards
	const extractUnitsFromDashboards = (dashboards) => {
		const unitsMap = {};
		dashboards.forEach((dashboard) => {
			(dashboard.unidades || []).forEach((unidade) => {
				if (unidade && unidade.id) {
					unitsMap[unidade.id] = unidade;
				}
			});
		});
		return Object.values(unitsMap);
	};

	// Função dummy para manter referência
	const handleRequest = () => {};

	// Recupera nome da unidade vinculada ao usuário
	const getNomeUnidadeUsuario = () => {
		const userCookie = Cookies.get('user');
		if (!userCookie) {
			return null;
		}

		let user;
		try {
			user = JSON.parse(userCookie);
		} catch (e) {
			return null;
		}

		if (!user?.perfil_unidades || user.perfil_unidades.length === 0) {
			return null;
		}

		const unidade =
			user.perfil_unidades.find((u) => u.ativo) ||
			user.perfil_unidades[0];

		const nome =
			unidade.unidade_nome ||
			unidade.nome ||
			unidade.unidade ||
			'Nome não encontrado';
		return nome;
	};

	// Função utilitária para obter nomes únicos de unidade
	const getUniqueUnitNames = (units) => {
		const seen = new Set();
		return units.filter((unit) => {
			const nome =
				unit.unidade_nome || unit.nome || unit.unidade || 'Sem nome';
			if (seen.has(nome)) return false;
			seen.add(nome);
			return true;
		});
	};

	useEffect(() => {
		fetchDashboards();
		if (Cookies.get('user')) {
			const user = JSON.parse(Cookies.get('user'));
			const cargo = user?.cargo || [];
			const groups = user?.groups || [];
			const permissao = user?.permissao || [];

			if (
				!cargo.includes('desenvolvedor') &&
				!user.unidade.includes('subhue')
			) {
				setIsOnlyUsuario(true);
				setWindowAlert(true);
			} else {
				setIsOnlyUsuario(false);
				if (cargo.includes('desenvolvedor')) {
					setUnitSelector(true);
					setWindowAlert(false);
				} else if (
					groups.includes('gestor') ||
					cargo.includes('gestor') ||
					permissao.includes('Gestores')
				) {
					handleRequest();
					setWindowAlert(false);
				}
			}
		} else {
			setWindowAlert(true);
			setIsOnlyUsuario(true);
		}
	}, [fetchDashboards]);

	// Atualize o useEffect para atualizar listUnits quando dashboards mudar
	useEffect(() => {
		setListUnits(extractUnitsFromDashboards(dashboards));
	}, [dashboards]);

	// Filtra os dashboards conforme os selects
	// ...existing code...

	// Filtra os dashboards conforme os selects
	const filteredDashboards = dashboards.filter((item) => {
		// Se o dashboard for nível gestor/subhue, só exibe para gestor/subhue
		if (item.subhue === true && isOnlyUsuario) {
			return false;
		}
		// Usuário gestor/subhue pode ver todos, então não bloqueia nada
		// Usuário comum só vê dashboards que não são subhue
		// (as duas regras acima já garantem isso)
		// Filtro por unidade (agora por nome, se selecionado)
		let unidadeMatch = true;
		if (selectedUnit) {
			const nomeSelecionado = selectedUnit;
			unidadeMatch =
				item.unidades &&
				item.unidades.some(
					(unidade) =>
						(unidade.unidade_nome ||
							unidade.nome ||
							unidade.unidade ||
							'Sem nome') === nomeSelecionado
				);
		}
		const categoriaMatch =
			!selectedCategoria || item.categoria_nome === selectedCategoria;
		const nomeDashboardMatch =
			!selectedDashboardName || item.nome === selectedDashboardName;
		return unidadeMatch && categoriaMatch && nomeDashboardMatch;
	});

	if (selectedDashboard) {
		return (
			<>
				<div className='flex flex-col mx-auto min-h-screen'>
					<NavBar />
					<div className='flex-5 flex flex-col items-center justify-center bg-[#F0F4F8] min-h-screen pt-[80px] pb-8'>
						<div className='w-full max-w-[90%] mx-auto sm:flex sm:flex-row sm:items-start sm:justify-center flex-col items-center gap-4'>
							<button
								className='text-white bg-[#004A80] hover:bg-[#004a80cc] rounded-lg font-semibold px-5 py-1.5 active:border-2 active:border-white mt-5'
								onClick={() => setSelectedDashboard(null)}>
								Voltar
							</button>

							<iframe
								src={selectedDashboard.link}
								title={selectedDashboard.nome}
								className='w-full max-w-[1300px] h-[750px] rounded-lg shadow-lg mt-5'
								style={{ border: 0 }}
								allowFullScreen
							/>
						</div>
					</div>
					<Footer />
				</div>
			</>
		);
	}

	return (
		<>
			<div className='flex flex-col mx-auto min-h-screen'>
				<NavBar />
				<div className='flex-grow'>
					<div className='bg-[#F0F4F8] mt-[80px] w-full shadow-md font-inter'>
						<div className='max-w-7xl mx-auto flex flex-col items-center justify-center py-6 px-4'>
							<span className='text-[#004A80] font-semibold text-[20px] md:text-[32px] text-center'>
								Painéis de monitoramento
							</span>
							{windowAlert && isOnlyUsuario && (
								<>
									{/* Subtítulo: nome da unidade associada */}
									<span className='text-[#004A80] font-semibold text-[14px] md:text-[18px] mt-2 text-center block'>
										{listUnits.map((unit, idx) => (
											<span key={unit.id || idx}>
												{unit.unidade_nome ||
													unit.nome ||
													unit.unidade ||
													'Sem nome'}
												{idx < listUnits.length - 1
													? ', '
													: ''}
											</span>
										))}
									</span>
								</>
							)}
						</div>
					</div>

					<section className='w-full bg-white py-12'>
						<div className='max-w-7xl mx-auto px-4'>
							{/* Filtros */}
							<div className='flex flex-wrap justify-center items-center gap-8 mb-10'>
								{/* Select de unidade */}
								{!windowAlert && !isOnlyUsuario && (
									<select
										className='h-[34px] w-[350px] px-3 border border-gray-300 rounded-md text-gray-700 text-sm focus:outline-none focus:ring-2 focus:ring-[#13335A] shadow-sm'
										value={selectedUnit}
										onChange={(e) =>
											setSelectedUnit(e.target.value)
										}>
										<option value=''>
											Nome da unidade
										</option>
										{getUniqueUnitNames(listUnits).map(
											(unit) => {
												const nome =
													unit.unidade_nome ||
													unit.nome ||
													unit.unidade ||
													'Sem nome';
												return (
													<option
														key={nome}
														value={nome}>
														{nome}
													</option>
												);
											}
										)}
									</select>
								)}

								{/* Select de categoria */}
								<select
									className='h-[34px] w-[350px] px-3 border border-gray-300 rounded-md text-gray-700 text-sm focus:outline-none focus:ring-2 focus:ring-[#13335A] shadow-sm'
									value={selectedCategoria}
									onChange={(e) =>
										setSelectedCategoria(e.target.value)
									}>
									<option value=''>Categoria</option>
									{[
										...new Set(
											dashboards.map(
												(d) => d.categoria_nome
											)
										),
									]
										.filter(Boolean)
										.map((categoria, idx) => (
											<option
												key={idx}
												value={categoria}>
												{categoria}
											</option>
										))}
								</select>
								{/* Select de nome do dashboard */}
								{!windowAlert && !isOnlyUsuario && (
									<select
										className='h-[34px] w-[350px] px-3 border border-gray-300 rounded-md text-gray-700 text-sm focus:outline-none focus:ring-2 focus:ring-[#13335A] shadow-sm'
										value={selectedDashboardName}
										onChange={(e) =>
											setSelectedDashboardName(
												e.target.value
											)
										}>
										<option value=''>
											Nome do dashboard
										</option>
										{[
											...new Set(
												dashboards.map((d) => d.nome)
											),
										]
											.filter(Boolean)
											.map((nome, idx) => (
												<option
													key={idx}
													value={nome}>
													{nome}
												</option>
											))}
									</select>
								)}
							</div>
						</div>
					</section>
					<div className='max-w-7xl mx-auto px-4 mt-0 mb-10'>
						{/* Cards */}
						<div className='flex flex-wrap justify-center gap-x-12 gap-y-12 text-[#757575] mt-0'>
							{filteredDashboards.map((item, idx) => (
								<div
									key={item.id || idx}
									className='bg-[#f5f5f5] rounded-[5px] flex flex-col items-center shadow-md transition duration-300 hover:scale-105 hover:shadow-xl cursor-pointer'
									style={{
										width: '100%',
										maxWidth: 300,
										minWidth: 180,
										paddingTop: 24,
										paddingBottom: 16,
										flex: '1 1 240px',
									}}
									onClick={() =>
										item.link && setSelectedDashboard(item)
									}
									title={item.nome}>
									<div className='w-full flex justify-center'>
										{/* Mostra o ícone se existir, senão mostra o placeholder */}
										{item.icone ? (
											<img
												src={item.icone}
												alt='Ícone do painel'
												className='rounded-lg'
												width={250}
												height={250}
												style={{ objectFit: 'contain' }}
											/>
										) : (
											<div
												className='w-full'
												style={{
													maxWidth: 150,
													minWidth: 150,
													aspectRatio: '1/1',
												}}>
												<div
													className='w-full h-full bg-[#D9D9D9] rounded-lg flex items-center justify-center'
													style={{ minHeight: 150 }}>
													{/* SVG de gráfico como fallback */}
													<svg
														width='80'
														height='80'
														fill='none'
														viewBox='0 0 48 48'>
														<rect
															width='48'
															height='48'
															rx='8'
															fill='#004A80'
														/>
														<path
															d='M16 32V24M24 32V16M32 32V20'
															stroke='#fff'
															strokeWidth='3'
															strokeLinecap='round'
														/>
													</svg>
												</div>
											</div>
										)}
									</div>
									<hr
										className='w-[85%] border-t border-[#D9D9D9]'
										style={{
											marginTop: '15px',
											marginBottom: '8px',
											borderTopWidth: 2,
										}}
									/>
									<div className='w-full flex flex-col items-center'>
										<p className='text-[16px] font-normal text-[#757575] text-center m-0 truncate w-full max-w-[220px]'>
											{item.nome}
										</p>
										{/* Exibe a(s) unidade(s) vinculada(s) ao dashboard, somente para gestor */}
										{!isOnlyUsuario &&
											item.unidades &&
											item.unidades.length > 0 && (
												<span className='text-[#004A80] text-[10px] font-medium text-center mt-1 block truncate'>
													{item.unidades.map(
														(u, i) => [
															u.unidade_nome ||
																u.nome ||
																u.unidade ||
																'Sem nome',
															i <
															item.unidades
																.length -
																1
																? ', '
																: '',
														]
													)}
												</span>
											)}
									</div>
								</div>
							))}
						</div>
					</div>
				</div>
				<Footer />
			</div>
		</>
	);
};

export default PaineisMonitoramento;
